import { ShoesState, ShoesAction } from 'src/types'
import {
  SET_SELECTED_PARTS,
  SET_BASE_MODEL,
  SET_EMBROIDERIES,
  ADD_EMBROIDERY,
  REMOVE_EMBROIDERY,
  SET_PERSONAL,
  SET_FIGURE_PANEL_NUMBER
} from 'src/features/atoms/glove/japan/constants/actionType'
import { initialEmbroideryState } from 'src/features/atoms/glove/japan/slice'
import { initialPersonalState, unselectedColorState, unselectedState, unselectedStateWithPrice } from 'src/constants'
import { SHOES_DISPATCHER } from '../constants/action'
import { getUpperMaterial } from '../logic'
import { MOCK_SHOES_STATE } from '../constants/mock'
import { doubleLine } from '../constants/base'

export const initialShoesState: ShoesState = {
  baseModel: {
    productNumber: 'shoes-1',
    brand: 'atoms',
    size: 0,
    description: '',
    image: {
      url: '',
      width: 0,
      height: 0
    }
  },
  // base
  upperMaterial: unselectedState,
  size: unselectedState,
  openingPattern: unselectedStateWithPrice,
  vampStrapType: unselectedStateWithPrice,
  tongue: unselectedState,
  outSole: unselectedState,
  lineType: unselectedStateWithPrice,
  toeGuard: unselectedStateWithPrice,
  toeGuardKind: unselectedStateWithPrice,
  // color
  line: unselectedColorState,
  line2: unselectedColorState,
  vampStrap: unselectedColorState,
  vampStrapBelt1: unselectedColorState,
  vampStrapBelt2: unselectedColorState,
  vampStrapBelt3: unselectedColorState,
  stitch: { ...unselectedState, color: '#eee' },
  tongueLinings: unselectedColorState,
  middleCutOpening: unselectedColorState,
  atomsLabel: unselectedColorState,
  magicBeltBase: unselectedColorState,
  magicBeltMaterial: unselectedState,
  toeGuardColor: unselectedColorState,

  parts: { value: 'whole', label: '全体' },
  whole: unselectedColorState,
  mainUnit: unselectedColorState,
  toeReinforcement: unselectedColorState,
  vampStrapReinforcement: unselectedColorState,
  healReinforcement: unselectedColorState,
  sideReinforcement: unselectedColorState,
  openingReinforcement: unselectedColorState,
  opening: unselectedColorState,
  healDecoration: unselectedColorState,
  tongueFront: unselectedColorState,

  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 0,
  images: {
    front: '',
    side: '',
    rear: ''
  }
}

export const shoesReducer = (state: ShoesState, action: ShoesAction): ShoesState => {
  const {
    // base -
    upperMaterial,
    size,
    openingPattern,
    vampStrapType,
    tongue,
    outSole,
    lineType,
    toeGuard,
    toeGuardKind,
    // parts -
    parts,
    whole,
    mainUnit,
    toeReinforcement,
    vampStrapReinforcement,
    healReinforcement,
    sideReinforcement,
    openingReinforcement,
    opening,
    healDecoration,
    tongueFront,
    toeGuardColor,

    // sub color
    line,
    line2,
    vampStrap,
    vampStrapBelt1,
    vampStrapBelt2,
    vampStrapBelt3,
    stitch,
    tongueLinings,
    middleCutOpening,
    atomsLabel,
    magicBeltMaterial,
    magicBeltBase
  } = SHOES_DISPATCHER

  switch (action.type) {
    case SET_SELECTED_PARTS:
      return { ...state, parts: action.parts }
    case SET_BASE_MODEL:
      return {
        ...state,
        baseModel: action.baseModel,
        lineType: doubleLine
      }
    // base
    case upperMaterial:
      return { ...state, upperMaterial: action.upperMaterial }
    case size:
      const newSize = action.size.value === 'unselected' ? unselectedState : action.size
      return { ...state, size: newSize }
    case openingPattern:
      return { ...state, openingPattern: action.openingPattern }
    case vampStrapType:
      const isChangeToLace = state.vampStrapType.value !== 'laceType' && action.vampStrapType.value === 'laceType'
      return { ...state, vampStrapType: action.vampStrapType, vampStrap: isChangeToLace ? unselectedColorState : state.vampStrap }
    case tongue:
      return { ...state, tongue: action.tongue }
    case outSole:
      return { ...state, outSole: action.outSole }
    case lineType:
      return { ...state, lineType: action.lineType }
    case toeGuard:
      return { ...state, toeGuard: action.toeGuard }
    case toeGuardKind:
      return { ...state, toeGuardKind: action.toeGuardKind }
    // parts
    case parts:
      return { ...state, parts: action.parts }
    case whole:
      const { isMesh } = getUpperMaterial(state)
      return {
        ...state,
        whole: action.whole,
        mainUnit: isMesh ? state.mainUnit : action.whole,
        tongueFront: isMesh ? state.mainUnit : action.whole,
        toeReinforcement: action.whole,
        vampStrapReinforcement: action.whole,
        healReinforcement: action.whole,
        sideReinforcement: action.whole,
        openingReinforcement: action.whole,
        opening: action.whole,
        healDecoration: action.whole
      }
    case mainUnit:
      return { ...state, mainUnit: action.mainUnit }
    case toeReinforcement:
      return { ...state, toeReinforcement: action.toeReinforcement }
    case vampStrapReinforcement:
      return { ...state, vampStrapReinforcement: action.vampStrapReinforcement }
    case healReinforcement:
      return { ...state, healReinforcement: action.healReinforcement }
    case sideReinforcement:
      return { ...state, sideReinforcement: action.sideReinforcement }
    case openingReinforcement:
      return { ...state, openingReinforcement: action.openingReinforcement }
    case opening:
      return { ...state, opening: action.opening }
    case healDecoration:
      return { ...state, healDecoration: action.healDecoration }
    case tongueFront:
      return { ...state, tongueFront: action.tongueFront }
    // color
    case line:
      return { ...state, line: action.line }
    case line2:
      return { ...state, line2: action.line2 }
    case vampStrap:
      const newVampStrap = action.vampStrap.value === 'unselected' ? unselectedColorState : action.vampStrap
      return { ...state, vampStrap: newVampStrap, vampStrapBelt1: newVampStrap, vampStrapBelt2: newVampStrap, vampStrapBelt3: newVampStrap }
    case vampStrapBelt1:
      const newVampStrapBelt1 = action.vampStrapBelt1.value === 'unselected' ? unselectedColorState : action.vampStrapBelt1
      return { ...state, vampStrapBelt1: newVampStrapBelt1 }
    case vampStrapBelt2:
      const newVampStrapBelt2 = action.vampStrapBelt2.value === 'unselected' ? unselectedColorState : action.vampStrapBelt2
      return { ...state, vampStrapBelt2: newVampStrapBelt2 }
    case vampStrapBelt3:
      const newVampStrapBelt3 = action.vampStrapBelt3.value === 'unselected' ? unselectedColorState : action.vampStrapBelt3
      return { ...state, vampStrapBelt3: newVampStrapBelt3 }
    case stitch:
      return { ...state, stitch: action.stitch }
    case tongueLinings:
      return { ...state, tongueLinings: action.tongueLinings }
    case middleCutOpening:
      return { ...state, middleCutOpening: action.middleCutOpening }
    case toeGuardColor:
      return { ...state, toeGuardColor: action.toeGuardColor }
    case atomsLabel:
      return { ...state, atomsLabel: action.atomsLabel }
    case magicBeltMaterial:
      return { ...state, magicBeltMaterial: action.magicBeltMaterial }
    case magicBeltBase:
      return { ...state, magicBeltBase: action.magicBeltBase }
    case SET_EMBROIDERIES:
      return { ...state, embroideries: action.embroideries }
    case ADD_EMBROIDERY: // incrementの方が合っている気がする
      return { ...state, embroideries: action.embroideries }
    case REMOVE_EMBROIDERY: // decrementの方が合っている気がする
      return { ...state, embroideries: action.embroideries }
    case SET_PERSONAL:
      return { ...state, personal: action.personal }
    case SET_FIGURE_PANEL_NUMBER:
      return { ...state, figurePanelNum: action.figurePanelNum }
    case SHOES_DISPATCHER.setShoesState:
      return MOCK_SHOES_STATE
    default:
      return state
  }
}
